var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.$t('common.labels.logout')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }